import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { fg } from '@atlaskit/platform-feature-flags';
import { TooltipPrimitive } from '@atlaskit/tooltip';
import { isFedRamp } from '@atlassian/atl-context';
import { messages } from '../../experience-application/messages';
import failedStateMessages from '../../messages';
import { messages as panelMessages } from './messages';
export var TRUST_URL = 'https://www.atlassian.com/trust/atlassian-intelligence';
export var getErrorMessage = function getErrorMessage(content) {
  switch (content) {
    case 'INPUT_EXCEEDS_TOKEN_LIMIT':
      return failedStateMessages.tokenLimitExceeded;
    case 'INPUT_TOO_SHORT_TO_SUMMARIZE':
      return failedStateMessages.inputTooShortError;
    case 'INPUT_TOO_SHORT_TO_PROCESS':
      return failedStateMessages.inputTooShortError;
    case 'RATE_LIMIT':
      return failedStateMessages.rateLimitEnforced;
    case 'OPENAI_RATE_LIMIT_USER_ABUSE':
      return failedStateMessages.rateLimitEnforced;
    case 'NO_AGENT':
      return failedStateMessages.internalServerError;
    case 'FEATURE_DISABLED_ON_SITE':
      return failedStateMessages.internalServerError;
    case 'FEATURE_DISABLED':
      return failedStateMessages.internalServerError;
    case 'INTERNAL_SERVER_ERROR':
      return failedStateMessages.internalServerError;
    case 'PLUGIN_ERRORED':
      return failedStateMessages.internalServerError;
    case 'HIPAA_CONTENT_DETECTED':
      return failedStateMessages.hipaaContentError;
    case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
      return failedStateMessages.tokenLimitExceeded;
    default:
      return failedStateMessages.apiError;
  }
};
export var getAupViolationMessage = function getAupViolationMessage(formatMessage) {
  return formatMessage(messages.aupViolationMessage, {
    auplink: function auplink(chunks) {
      return /*#__PURE__*/React.createElement("a", {
        href: "https://www.atlassian.com/legal/acceptable-use-policy",
        target: "_blank"
      }, chunks);
    }
  });
};
export var getInternalServerErrorMessage = function getInternalServerErrorMessage(formatMessage) {
  return formatMessage(failedStateMessages.internalServerError, {
    link: function link(chunks) {
      return /*#__PURE__*/React.createElement("a", {
        href: "https://status.atlassian.com/",
        target: "_blank"
      }, chunks);
    }
  });
};
var getContentQualityMessage = function getContentQualityMessage(formatMessage) {
  return formatMessage(panelMessages.contentQualityMayVary, {
    link: function link(chunks) {
      return /*#__PURE__*/React.createElement("a", {
        href: TRUST_URL,
        target: "_blank"
      }, chunks);
    }
  });
};
export var getRateLimitErrorMessage = function getRateLimitErrorMessage(formatMessage) {
  return formatMessage(failedStateMessages.rateLimitEnforced, {
    link: function link(chunks) {
      return /*#__PURE__*/React.createElement("a", {
        href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
        target: "_blank"
      }, chunks);
    }
  });
};
export var isAIPanelsEnabled = function isAIPanelsEnabled() {
  /**
   * WARNING: Do not remove the isFedRamp check.
   * This is to ensure that AI functionality is not enabled in FedRamp environments.
   */
  if (isFedRamp()) {
    return false;
  }
  var aiPanelsEnabled = false;
  if (fg('platform_editor_ai_enable_ai_summary_blocks')) {
    aiPanelsEnabled = true;
  }
  if (fg('platform_editor_ai_enable_ai_action_items_block')) {
    aiPanelsEnabled = true;
  }
  return aiPanelsEnabled;
};
export var getRegenerateToolbarItem = function getRegenerateToolbarItem(intl, api, extensionKey, messages) {
  return {
    key: 'regenerate-button',
    label: intl.formatMessage(messages.regenerateButtonLabel),
    display: 'icon-and-label',
    tooltip: intl.formatMessage(messages.regenerateButtonTooltip),
    icon: function icon() {
      return import('@atlaskit/icon/glyph/retry').then(function (mod) {
        return mod.default;
      });
    },
    action: function () {
      var _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(adf) {
        var _adf$attrs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!((_adf$attrs = adf.attrs) !== null && _adf$attrs !== void 0 && _adf$attrs.localId) || !api || !api.aiExperience)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              api.aiExperience.actions.regenerateExtension(api, adf.attrs.localId, extensionKey);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function action(_x) {
        return _action.apply(this, arguments);
      }
      return action;
    }(),
    disabled: !api || !api.aiExperience
  };
};
export var getFeedbackToolbarItem = function getFeedbackToolbarItem(intl, api, messages) {
  return {
    key: 'feedback-button',
    label: intl.formatMessage(messages.feedbackButtonLabelTooltip),
    display: 'icon',
    tooltip: intl.formatMessage(messages.feedbackButtonLabelTooltip),
    icon: function icon() {
      return import('@atlaskit/icon/glyph/editor/feedback').then(function (mod) {
        return mod.default;
      });
    },
    action: function () {
      var _action2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(adf) {
        var _adf$attrs2, _adf$attrs3, _adf$attrs4, _api$analytics;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!((_adf$attrs2 = adf.attrs) !== null && _adf$attrs2 !== void 0 && _adf$attrs2.localId) || !api || !api.aiExperience)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              api.aiExperience.actions.triggerAIPanelFeedbackCollector(adf === null || adf === void 0 || (_adf$attrs3 = adf.attrs) === null || _adf$attrs3 === void 0 ? void 0 : _adf$attrs3.extensionKey, adf === null || adf === void 0 || (_adf$attrs4 = adf.attrs) === null || _adf$attrs4 === void 0 || (_adf$attrs4 = _adf$attrs4.parameters) === null || _adf$attrs4 === void 0 ? void 0 : _adf$attrs4.content, intl.locale, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 ? void 0 : _api$analytics.fireAnalyticsEvent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function action(_x2) {
        return _action2.apply(this, arguments);
      }
      return action;
    }(),
    disabled: !api || !api.aiExperience
  };
};
export var getQualityToolbarItem = function getQualityToolbarItem(intl) {
  return {
    key: 'quality-info',
    label: '',
    ariaLabel: intl.formatMessage(panelMessages.contentQualityMayVaryLabel),
    display: 'icon',
    tooltip: getContentQualityMessage(intl.formatMessage),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
    tooltipStyle: styled(TooltipPrimitive)({
      backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
      maxWidth: '220px',
      padding: "var(--ds-space-150, 12px)",
      borderRadius: "var(--ds-border-radius-100, 3px)",
      boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31))"
    }),
    icon: function icon() {
      return import('@atlaskit/icon/glyph/editor/panel').then(function (mod) {
        return mod.default;
      });
    },
    action: function () {
      var _action3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function () {
                window.open(TRUST_URL, '_blank');
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function action() {
        return _action3.apply(this, arguments);
      }
      return action;
    }()
  };
};